<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Missed Customers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Missed Customers",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Missed Customers",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsMissedCustomerPaginated: true,
      serverPerPage: 10,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      existingRole: [],
      reasonError: "",
      dateError: "",
      customerError: "",

      // Value from user input for adding Role
      data: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        customer_id: "",
        reason: "",
      },
      // edit Role
      editdata: {
        name: "",
        customer_id: "",
        date: "",
        reason: "",
        id: "",
      },
      // delete Role
      deletedata: {
        name: "",
        id: "",
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("customers", [
      "MissedCustomers",
      "Customers",
      "SaveStatus",
      "MissedCustomerPagination",
      "MissedCustomerPaginated"
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),

    missedCustomersColumns() {
      return [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) =>
            this.MissedCustomerPagination?.from
              ? this.MissedCustomerPagination.from + idx
              : idx + 1,
        },
        {
          key: "date",
          label: "DATE",
        },
        {
          key: "customer_name",
          label: "CUSTOMER",
          formatter: (_, row) => row.customer?.name || "N/A",
        },
        {
          key: "customer_contact",
          label: "CONTACT",
          formatter: (_, row) => row.customer?.contact || "N/A",
        },
        {
          key: "longitude",
          label: "LONG",
        },
        {
          key: "latitude",
          label: "LAT",
        },
        {
          key: "reason",
          label: "REASON",
        },
        {
          key: "user_name",
          label: "ADDED BY",
          formatter: (_, row) => row.user?.name || "N/A",
        },
        {
          key: "dateAdded",
          label: "DATE ADDED",
        },
        {
          key: "actions",
          label: "ACTIONS",
          tdClass: "text-nowrap",
        },
      ];
    },

    rows() {
      return this.IsMissedCustomerPaginated
        ? this.MissedCustomerPagination.total
        : this.MissedCustomers
        ? this.MissedCustomers.length
        : 0;
    },

   perPage: {
      get() {
        if (this.IsMissedCustomerPaginated) {
          return (
            (this.MissedCustomerPagination && this.MissedCustomerPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsMissedCustomerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchMissedCustomers(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.MissedCustomerPaginated && this.MissedCustomerPagination
          ? this.MissedCustomerPagination.current_page
          : 1;
      },
      set(value) {
        if (this.MissedCustomerPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchMissedCustomers: "customers/fetchMissedCustomers",
      FetchCustomers: "customers/fetchCustomers",
      AddMissedCustomer: "customers/addMissedCustomer",
      EditMissedCustomer: "customers/editMissedCustomer",
      DeleteMissedCustomer: "customers/deleteMissedCustomer",
    }),
    
    addMissed(modalId) {
      this.modal_id = modalId;

      if (this.data.date == "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }

      if (this.data.customer_id == "") {
        this.customerError = "Customer field is required";
        return;
      } else {
        this.customerError = "";
      }

      if (this.data.reason == "") {
        this.reasonError = "Reason field is required";
        return;
      } else {
        this.reasonError = "";
      }

      this.AddMissedCustomer(this.data);
    },

    resetAddCat() {
      this.data.reason = "";
      this.data.date = moment(new Date()).format("YYYY-MM-DD");
      this.data.customer_id = "";
      this.customerError = "";
      this.dateError = "";
      this.reasonError = "";
      this.modal_id = "";
    },

    resetEditCat() {
      this.editdata.name = "";
      this.editdata.customer_id = "";
      this.editdata.date = "";
      this.editdata.reason = "";
      this.editdata.id = "";
      this.reasonError = "";
      this.dateError = "";
      this.modal_id = "";
    },

    resetDeleteCat() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.reasonError = "";
      this.dateError = "";
      this.modal_id = "";
    },

    resetError() {
      this.reasonError = "";
      this.dateError = "";
    },

    showEditModal(data) {
      this.editdata.name = data.item.customer.name;
      this.editdata.customer_id = data.item.customer.id;
      this.editdata.date = data.item.date;
      this.editdata.reason = data.item.reason;
      this.editdata.id = data.item.id;
    },

    editCategory(modalId) {
      this.modal_id = modalId;
      if (this.editdata.date == "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      if (this.editdata.reason == "") {
        this.reasonError = "Reason field is required";
        return;
      } else {
        this.reasonError = "";
      }

      this.EditMissedCustomer(this.editdata);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item.customer.name;
      this.deletedata.id = data.item.id;
    },

    deleteCategory(modalId) {
      this.modal_id = modalId;
      this.DeleteMissedCustomer(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    handlePageChange(newPage) {
      if (this.IsMissedCustomerPaginated) {
        this.data.page = newPage;
        this.FetchMissedCustomers(this.data);
      }
    },
  },

  created() {
    this.FetchMissedCustomers(this.data);
    this.FetchCustomers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Missed Customers</h4>
              </div>
              <div class="col-md-3" align="right">
                <b-button v-b-modal.add-category-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6" v-if="!IsMissedCustomerPaginated">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="missedCustomersColumns"
                :rows="MissedCustomers || []"
                :total-rows="rows"
                :pagination="MissedCustomerPagination"
                :server-pagination="IsMissedCustomerPaginated"
                :loading="SaveStatus"
              >
                <template #cell(sn)="{ index }">
                  {{ MissedCustomerPagination.from + index }}
                </template>

                <template #cell(customer_name)="{ row }">
                  {{ row.customer?.name || "N/A" }}
                </template>

                <template #cell(customer_contact)="{ row }">
                  {{ row.customer?.contact || "N/A" }}
                </template>

                <template #cell(user_name)="{ row }">
                  {{ row.user?.name || "N/A" }}
                </template>

                <template #cell(actions)="{ row }">
                  <b-btn-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-category-modal
                      @click="showEditModal({ item: row })"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </b-button>
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-category-modal
                      @click="showDeleteModal({ item: row })"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </b-button>
                  </b-btn-group>
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-category-modal" hide-footer @hidden="resetAddCat">
      <template #modal-title> Add Missed Customer </template>
      <div class="form-group mb-3">
        <label>Date</label>
        <div class="input-group">
          <input
            type="date"
            class="form-control"
            @input="resetError()"
            v-model="data.date"
            v-limit-future-date
          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Select Customer <span class="text-danger">*</span></label>
        <model-list-select
          :list="Customers ? Customers : []"
          v-model="data.customer_id"
          option-value="id"
          option-text="name1"
          class="mb-3"
          placeholder="Select customer"
          @input="resetError()"
        >
        </model-list-select>

        <div class="text-danger" v-if="customerError">
          <em>{{ customerError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Reason <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Reason"
            class="form-control"
            @input="resetError()"
            v-model="data.reason"
          />
        </div>
        <div class="text-danger" v-if="reasonError">
          <em>{{ reasonError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-category-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addMissed('add-category-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- edit modal starts -->
    <b-modal id="edit-category-modal" hide-footer @hidden="resetEditCat">
      <template #modal-title>
        Edit Missed Customer {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Date</label>
        <div class="input-group">
          <input
            type="date"
            class="form-control"
            @input="resetError"
            v-model="editdata.date"
            v-limit-future-date
          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Reason</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError"
            v-model="editdata.reason"
          />
        </div>
        <div class="text-danger" v-if="reasonError">
          <em>{{ reasonError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-category-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editCategory('edit-category-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete category starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-category-modal"
      hide-footer
      @hidden="resetDeleteCat"
    >
      <template #modal-title>
        Deactivate Missed Customer {{ deletedata.name }}</template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to Deactivate this Missed Customer? Click Proceed Button
            to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-category-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteCategory('delete-category-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}


</style>
